export default __webpack_public_path__ + "static/media/header-devis.31998769.jpg";